var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-button',{staticClass:"spinner-wheel-spin-button",attrs:{"type":"button","size":"sm","disabled":_vm.disabled},on:{"click":_vm.spin}},[_c('aha-icon',{attrs:{"name":"play","viewBox":"0 0 24 24","width":_vm.iconSize,"height":_vm.iconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }